import { computed, inject, Injectable, Signal } from '@angular/core';
import { UserService } from './user.service';
import { switchMap } from 'rxjs';
import { DataService } from './data.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs/operators';
import { RRol } from '@cumlaude/service-contract';

interface MedewerkerPasfoto {
	mw_abb_medewerker: string;
	mw_pic_pasfoto: string | null;
}

@Injectable({
	providedIn: 'root',
})
export class PasfotoService {
	protected readonly userService = inject(UserService);
	protected readonly dataService = inject(DataService);

	private readonly pasfotos: Signal<MedewerkerPasfoto[] | undefined>;

	constructor() {
		this.pasfotos = toSignal(
			this.userService.rolChanged$.pipe(
				filter((rol) => rol !== undefined),
				filter((rol) => rol !== RRol.BESTUUR),
				switchMap(() => this.dataService.getMedewerkers<MedewerkerPasfoto>({ col: [['mw_abb_medewerker'], ['mw_pic_pasfoto']] })),
				map((response) => response.rows)
			)
		);
	}

	getPasfoto(pasfotoKey: string): Signal<string | null | undefined> {
		return computed(() => {
			const pasfotos = this.pasfotos();
			if (!pasfotos) return null;

			return pasfotos.find((pasfoto) => pasfoto.mw_abb_medewerker === pasfotoKey)?.mw_pic_pasfoto;
		});
	}
}
